import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { GoogleOAuthProvider } from '@react-oauth/google';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import theme from './infra/theme';

import './index.css';

import App from './App';

import store from './store';

const container = document.getElementById('root');

const root = createRoot(container);

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const AppTree = (
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </ThemeProvider>
);

root.render(
  googleClientId ? (
    <GoogleOAuthProvider clientId={googleClientId}>
      {AppTree}
    </GoogleOAuthProvider>
  ) : (
    AppTree
  )
);
